// Free-plan content gating. Everything else needs Premium.
export const FREE_SECTIONS = ["abc", "numbers"];
export const FREE_GAMES = ["memory", "catch-stars"];

export const isFreeSection = (id) => FREE_SECTIONS.includes(id);
export const isFreeGame = (id) => FREE_GAMES.includes(id);
